<template lang="pug">
    ExpandableCardListItem.mt-0.mb-5.mx-1.text-left(
        v-if="validAppointment"
        :color="itemColor"
        expandable
        :flex-grow-left="8"
        :is-expanded="showDetails === true"
        :on-expand="() => showDetails = !showDetails"
        :subtitle="vehicleYearMakeModel"
        :title="integrationAppointment.friendly_appointment_date_with_time_zone"
        title-alignment="center"
    )

        template(v-slot:body v-if="showDetails === true")
            v-card-text.white.text--primary
                v-list.py-0.text-left(
                    two-line
                )
                    template
                        ListItem(
                            default-title="N/a"
                            icon="mdi-store"
                            indent
                            subtitle="Service Shop"
                            :title="displayShopName(integrationAppointment.shop_sid)"
                        )
                        ListItem(
                            default-title="N/a"
                            icon="mdi-train-car"
                            indent
                            subtitle="Transportation Type"
                            :title="displayTransportName(integrationAppointment.transportation_type_sid) || formatTransportType(integrationAppointment.transport_type) || 'N/a'"
                        )
                        ListItem(
                            default-title="N/a"
                            icon="mdi-account-tie"
                            indent
                            subtitle="Service Advisor"
                            :title="displayAdvisorName(integrationAppointment.service_advisor_sid)"
                        )
                        ListItem(
                            v-if="validIntegrationServices"
                            default-title="N/a"
                            icon="mdi-wrench"
                            indent
                            subtitle="Service"
                            :title="displayServiceName(integrationAppointment.services)"
                        )
                        ListItem(
                            default-title="N/a"
                            icon="mdi-message-reply-text"
                            indent
                            subtitle="Customer Comments"
                            :title="integrationAppointment.comment || integrationAppointment.customer_comments"
                        )

                        v-row.justify-content-end(style="margin-top: 25px; margin-right: 15px; margin-bottom: 7px")
                            CancelDialog(
                                :current-campaign-customer="currentCampaignCustomer"
                                :current-integration="currentIntegration"
                                :display-details-view="displayDetailsView"
                                :get-integration-appointments="getIntegrationAppointments"
                                :handle-cancel-integration-appointment="handleCancelIntegrationAppointment"
                                :handle-close-details-on-cancel="handleCloseDetailsOnCancel"
                                :set-integration-error="setIntegrationError"
                                :show-snackbar="showSnackbar"
                                :set-integration-appointment-details="setIntegrationAppointmentDetails"
                                :integration-appointment="integrationAppointment"
                            )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import ExpandableCardListItem from '@/components/shared/expandable_card_list_item.vue';
    import ListItem from '@/components/shared/list_item.vue';
    import CancelDialog from '@/components/communication_center/shared/tabs/integration/cancel.vue'

    // Helpers
    import { resourceColorClass, } from "@/helpers/css_classes";

    export default Vue.extend({
        data() {
            return {
                showDetails: false,
            }
        },
        methods: {
            displayServiceName(services) {
                return services?.map(service => service.description).join(", ") || 'N/a';
            },
            displayShopName(shopSid) {
                return this.shopMap?.get(shopSid) || 'N/a';
            },
            displayTransportName(transportSid) {
                let transportName = this.transportMap?.get(transportSid)
                return this.formatTransportType(transportName) || ""; // intentionally left blank
            },
            formatTransportType(transportType) {
                return this.titleize(transportType?.toLowerCase()) || ""; // intentionally left blank
            },
            displayAdvisorName(advisorSid) {
                return this.advisorMap?.get(advisorSid) || 'N/a';
            },
            handleReschedule(){
                this.setScopedAppointment(this.integrationAppointment);
                this.displayRescheduleView();
            },
            //Ensures that all details cards are closed when you cancel an appointment to ensure user doesn't think the appt they canceled didn't cancel because of an open card. 
            handleCloseDetailsOnCancel(){
                this.showDetails = false;
            }
        },
        computed: {
            itemColor() {
                return resourceColorClass("Appointment");
            },
            validAppointment() {
                return this.integrationAppointment?.appointment_sid?.length > 0;
            },
            validIntegrationServices() {
                return this.integrationAppointment?.services?.length > 0;
            },
            integrationVehicle() {
                if (this.integrationAppointment?.vehicles?.length > 0 && this.integrationAppointment?.vehicles?.[0]?.vin?.length > 0) {
                    return this.integrationAppointment?.vehicles?.[0] || null; 
                }

                return this.integrationAppointment?.vehicle || null;
            },
            vehicleYearMakeModel() {
                // xtime response doesn't have vehicle info, you will not see this in the details card
                return (this.integrationVehicle?.year ? this.integrationVehicle?.year + ' ' : '') +
                    (this.integrationVehicle?.make ? this.integrationVehicle?.make + ' ' : '') +
                    (this.integrationVehicle?.model ? this.integrationVehicle?.model : '').trim();
            }
        },
        components: {
            CancelDialog,
            ExpandableCardListItem,
            ListItem,
        },
        props: {
            integrationAppointment: Object,
            currentCampaignCustomer: Object,
            currentIntegration: String,
            displayRescheduleView: Function,
            displayDetailsView: Function,
            setScopedAppointment: Function,
            setIntegrationAppointmentDetails: Function, 
            showSnackbar: Function,
            getIntegrationAppointments: Function,
            handleCancelIntegrationAppointment: Function, 
            setIntegrationError: Function, 
            titleize: Function,
            advisorMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            },
            transportMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            },
            shopMap: {
                validator(value) {
                    return value instanceof Map;
                },
                default: () => new Map()
            }
        },
        created() {
        }
    });
</script>

<style lang="scss" scoped>
</style>
